import { graphql } from "@/graphql/codegen"

import "./invoice.fragment"

graphql(`
  query GetInvoice($input: InvoiceGetInput!) {
    invoice {
      get(input: $input) {
        __typename
        ... on InvoiceGetSuccess {
          invoice {
            ...InvoiceBaseFields
            invoiceId
            vendorCompany {
              companyId
              name
              publicId
              externalSystemId
              types
              locationsAssociations {
                billing {
                  locationId
                  address1
                  address2
                  city
                  regionIsoCode
                  postalCode
                  countryIsoCode
                }
              }
            }
            createdByUser {
              firstName
              lastName
            }
            updatedByUser {
              firstName
              lastName
            }
          }
        }
        ... on InvoiceGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query CheckInvoiceDuplicates($input: InvoiceDuplicateCheckInput!) {
    invoice {
      checkDuplicates(input: $input) {
        __typename
        duplicates {
          ...InvoiceBaseFields
          vendorCompany {
            companyId
            name
          }
        }
      }
    }
  }
`)
